<template>
  <fm-modal title="提交" v-model="modal" width="600px" v-if="modal">
    <fm-form label-align="left">
      <fm-form-item label="提报科室" v-if="updateKeys && updateKeys.split(',').includes('submitOrgId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.submitOrgId">
          <fm-option v-for="item in submitOrgList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="采购方式分管领导" v-if="updateKeys && updateKeys.split(',').includes('purchaseMethodLeadUserId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.purchaseMethodLeadUserId">
          <fm-option v-for="item in purchaseMethodLeadUserList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="院长" v-if="updateKeys && updateKeys.split(',').includes('deanUserId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.deanUserId">
          <fm-option v-for="item in deanUserList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
    </fm-form>
    <div class="model-btn">
      <fm-btn style="margin-right: 30px;" @click="formSubmit">提交</fm-btn>
      <fm-btn @click="modal = false">取消</fm-btn>
    </div>
  </fm-modal>
</template>

<script>
export default {
  props: {
    updateKeys: { type: String, defualt: null },
    batchData: {
      type: Object
    }
  },
  data () {
    return {
      formData: {},
      modal: false
    }
  },
  computed: {
    submitOrgList () {
      let submitOrgIds = this.batchData && this.batchData.submitOrgIds ? this.batchData.submitOrgIds.split(',').map(v => Number(v)) : []
      return this.$store.getters.orgList.filter(v => submitOrgIds.includes(v.data.id))
    },
    purchaseMethodLeadUserList () {
      let purchaseMethodLeadUserIds = this.batchData && this.batchData.purchaseMethodLeadUserIds ? this.batchData.purchaseMethodLeadUserIds.split(',').map(v => Number(v)) : []
      return this.$store.getters.userList.filter(v => purchaseMethodLeadUserIds.includes(v.data.id))
    },
    deanUserList () {
      let deanUserIds = this.batchData && this.batchData.deanUserIds ? this.batchData.deanUserIds.split(',').map(v => Number(v)) : []
      return this.$store.getters.userList.filter(v => deanUserIds.includes(v.data.id))
    }
  },
  methods: {
    async formSubmit () {
      let pass = true
      this.updateKeys.split(',').forEach(v => {
        if (!this.formData[v]) {
          pass = false
        }
      })
      if (!pass) {
        this.$notify({
          title: '系统提示',
          message: '请检查表单',
          type: 'info'
        })
      } else {
        this.$emit('submit', this.formData)
        this.modal = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.model-btn {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>